import React from "react";
import WarmTierRepositorySetupText from "data-tiering/WarmTierRepositorySetupText";
import WarmTierSnapshotsText from "data-tiering/WarmTierSnapshotsText";
import { Alert } from "components/bootstrap";
import { Spinner } from "components/common";
import useDataTiering from "./hooks/useDataTiering";
const WarmTierReadinessInfo = () => {
  const { readiness } = useDataTiering();
  if (readiness.isLoading) return /* @__PURE__ */ React.createElement(Spinner, { text: "Fetching readiness information..." });
  const introductionText = "Your Opensearch Cluster is not configured to use the Warm Tier.";
  const alertText = () => {
    var _a, _b, _c;
    if (!((_a = readiness.data) == null ? void 0 : _a.details.supported_by_search_version)) {
      return /* @__PURE__ */ React.createElement("p", null, "Your Open Search version does not support Searchable Snapshots.");
    }
    if (!((_b = readiness.data) == null ? void 0 : _b.details.restored_snapshots_assignable)) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, introductionText), /* @__PURE__ */ React.createElement(WarmTierSnapshotsText, null));
    }
    if (((_c = readiness.data) == null ? void 0 : _c.details.supported_repository_types.length) === 0) {
      return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("p", null, introductionText), /* @__PURE__ */ React.createElement(WarmTierRepositorySetupText, null));
    }
    return null;
  };
  if (readiness.data.ready) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(Alert, { bsStyle: "warning", title: "Cluster not ready for Warm Tier" }, alertText());
};
export default WarmTierReadinessInfo;
